module.exports = __webpack_public_path__ + "img/all-templates.978a14f3.svg";